import { useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { EMAIL_PATTERN, FORGOT_TITLE, LOGIN_TITLE, PHONE_NUMBERS, SIGNUP_TITLE } from "../../utils/global";
// @ts-ignore
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from "react-google-login";
// @ts-ignore
import useState from 'react-usestateref';
import * as AuthService from '../../services/Auth';
import { AuthUser, FacebookAuthData, FullName, GoogleAuthData, PhoneNumber } from "../../utils/interface";
import Cookies from "js-cookie";
import { useToasts } from 'react-toast-notifications';

import Modal from 'react-modal';
import { AppDispatch } from "../../store";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '40%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const Login = ({
  nextAction,
  classname,
  actionText,
  closeModal,
}: {
  nextAction?: any,
  classname?: string,
  actionText?: string,
  closeModal?: any,
}) => {
  type Inputs = {
    email?: string,
    password?: string,
    name?: {
      first?: string,
      last?: string,
    },
    phoneNumber?: PhoneNumber,
  };

  const [title, setTitle] = useState<string>(SIGNUP_TITLE);

  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation('common');

  const { addToast } = useToasts();

  const { register, unregister, handleSubmit, formState: { isDirty, isValid } } = useForm<Inputs>({
    mode: "onChange"
  });

  const signUpFacebook = async (phoneNumber: PhoneNumber) => {
    try {
      const res = await AuthService.signUpFacebook(userCurrent.current.token, phoneNumber);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  const signUpGoogle = async (phoneNumber: PhoneNumber) => {
    try {
      const res = await AuthService.signUpGoogle(userCurrent.current.token, phoneNumber);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  const signUpEmail = async (email: string, password: string, name?: FullName, phoneNumber?: PhoneNumber) => {
    try {
      const res = await AuthService.signUpEmail(email, password, name, phoneNumber);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  const signInEmail = async (email: string, password: string, phoneNumber?: PhoneNumber) => {
    try {
      const res = await AuthService.signInEmail(email, password, phoneNumber);
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  const onSubmit = async (data: Inputs) => {
    let response: any;

    if (data?.phoneNumber) {
      data.phoneNumber.countryCode = codePhoneNumberSelected;
    }

    try {
      setLoading(true);
      // proceso el login si completo password o telefono o nombres
      if (optionAuth == 'facebook') {
        response = await signUpFacebook(data.phoneNumber);
      }

      if (optionAuth == 'google') {
        response = await signUpGoogle(data.phoneNumber);
      }

      if (optionAuth == 'email') {
        if (resetPasswordIsAvailable) {
          if (data.phoneNumber) {
            response = await signInEmail(user.email, data.password, data.phoneNumber);
          } else {
            response = await signInEmail(user.email, data.password);
          }
        } else {
          response = await signUpEmail(user.email, data.password, data.name, data.phoneNumber);
        }
      }

      logginUser(response);
      setLoading(false);
      nextAction();
    } catch(error) {
      setLoading(false);
      addToast(error.message, { appearance: 'error' });
    }
  }

  const handleSocialLoginFailure = (event: any) => console.log(event, 'fail');

  const [loginStep, setLoginStep] = useState<boolean>(true);
  const [forgetPassStep, setForgetPassStep] = useState<boolean>(false);
  const [emailSentStep, setEmailSentStep] = useState<boolean>(false);

  const [optionAuth, setOptionAuth, optionAuthCurrent] = useState<string>('');

  const [user, setUser, userCurrent] = useState<AuthUser>({
    email: '',
    password: '',
  });

  const [passwordIsRequired, setPasswordIsRequired] = useState<boolean>(false);
  const [phoneNumberIsRequired, setPhoneNumberIsRequired] = useState<boolean>(false);
  const [namesIsRequired, setNamesIsRequired] = useState<boolean>(false);
  const [resetPasswordIsAvailable, setResetPasswordIsAvailable] = useState<boolean>(false);

  const [codePhoneNumberSelected, setCodePhoneNumberSelected] = useState<string>(PHONE_NUMBERS[0].code);

  const dispatch: AppDispatch = useDispatch();

  const logginUser = (res: {
    user: any,
    token: string,
  }) => {
    Cookies.set("user", JSON.stringify(res.user));
    Cookies.set("token", res.token);
    console.log("cookie: " + res.token);
    dispatch({
      type: 'SET_USER',
      payload: JSON.stringify(res.user),
    });
    dispatch({
      type: 'SET_TOKEN',
      payload: res.token,
    });
  };

  const checkUser = async () => {
    // llama a servicio para ver si es usuario y me dira si phoneNumber es require o no
    // mandar email al servicio
    // va a la vista
    // phoneNumber si o no segun el response del check
    setPasswordIsRequired(false);
    setPhoneNumberIsRequired(false);

    if (optionAuthCurrent.current == "email") {
      const res = await AuthService.signInCheck(user.email, undefined, undefined)

      if (res.data?.signup) {
        const {
          phoneNumber,
          name,
        } = res.data.signup?.missing;

        setPhoneNumberIsRequired(phoneNumber ? true : false);
        setNamesIsRequired(name ? true : false);
        setPasswordIsRequired(true);
        setTitle(SIGNUP_TITLE);
      }

      if (res.data.login) {
        setPhoneNumberIsRequired(res.data.login?.missing?.phoneNumber ? true : false);
        setPasswordIsRequired(true);
        setResetPasswordIsAvailable(true);
        setTitle(LOGIN_TITLE);
      }
    } else if (optionAuthCurrent.current == "facebook") {
      // facebook
      const res = await AuthService.signInCheck(undefined, userCurrent.current.tokenSN, undefined)
      if (res.data.signup) {
        const {
          missing: {
            phoneNumber,
            name,
          },
          tokenFacebook,
        } = res.data?.signup;

        setPhoneNumberIsRequired(phoneNumber ? true : false);
        setNamesIsRequired(name ? true : false);
        setUser({
          ...user,
          token: tokenFacebook,
        });
        setTitle(SIGNUP_TITLE);
      } else if (res.data.ok) {
        logginUser(res.data.ok);
        nextAction();
      } else if (res.data?.login?.missing) {
        setPhoneNumberIsRequired(res.data?.login?.missing?.phoneNumber ? true : false);
        setNamesIsRequired(res.data?.login?.missing?.name ? true : false);
        setUser({
          ...user,
          token: res.data?.login?.tokenFacebook,
        });
        setTitle(LOGIN_TITLE);
      }
    } else {
      // google
      const res = await AuthService.signInCheck(undefined, undefined, userCurrent.current.tokenSN);
      if (res.data.signup) {
        const {
          missing : {
            phoneNumber,
            name,
          },
          tokenGoogle,
        } = res.data.signup;
        setPhoneNumberIsRequired(phoneNumber ? true : false);
        setNamesIsRequired(name ? true : false);
        setUser({
          ...user,
          token: tokenGoogle,
        });
        setTitle(SIGNUP_TITLE);
      } else if (res.data.ok) {
        logginUser(res.data.ok);
        nextAction();
      } else if (res.data?.login?.missing) {
        setPhoneNumberIsRequired(res.data?.login?.missing?.phoneNumber ? true : false);
        setNamesIsRequired(res.data?.login?.missing?.name ? true : false);
        setUser({
          ...user,
          token: res.data?.login?.tokenGoogle,
        });
        setTitle(LOGIN_TITLE);
      }
    }
    setLoginStep(false);
    setLoading(false);
  };

  const authEmail = () => {
    setLoading(true);
    setOptionAuth('email');
    checkUser();
  }

  const handleUserEmail = (e: any) => {
    setUser({...user, email: e.target.value});
  };

  const pressEnter = (e: any) => {
    if (EMAIL_PATTERN.test(user.email) && e.keyCode == 13) {
      // enter pressed
      authEmail();
    }
  };

  const handleFacebookLogin = (data: FacebookAuthData) => {
    try {
      setLoading(true);
      if (data?.status !== "unknown") {
        setOptionAuth('facebook');
        setUser({...user, tokenSN: data.accessToken});
        checkUser();
      }
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const handleGoogleLogin = (data: GoogleAuthData) => {
    setLoading(true);
    setOptionAuth('google');
    setUser({...user, tokenSN: data.tokenId});
    checkUser();
  };

  const resetLogin = () => {
    setLoading(false);
    setEmailSentStep(false);
    setTitle(SIGNUP_TITLE);
    setLoginStep(true);
    setForgetPassStep(false);
    setOptionAuth('')
    setUser({
      email: '',
      password: '',
    });
    setPasswordIsRequired(false);
    unregister('password', 
      { keepDirty: true },
    );
    unregister('name.last', 
      { keepDirty: true },
    );
    unregister('name.first', 
      { keepDirty: true },
    );
    unregister('phoneNumber.number', 
      { keepDirty: true },
    );
    setPhoneNumberIsRequired(false);
    setNamesIsRequired(false);
    setResetPasswordIsAvailable(false);
  };

  const goToForgotPassword = () => {
    setForgetPassStep(true);
    setTitle(FORGOT_TITLE);
  };

  const forgetPassword = async () => {
    setLoading(true);
    try {
      await AuthService.forgotPassword(userCurrent.current.email);
      setLoading(false);
      setForgetPassStep(false);
      setEmailSentStep(true);
    } catch (error) {
      setLoading(false);
      addToast(error.message, { appearance: 'error' });
    }
  };

  return (
    <div className={`container ${classname}`}>
      <div className={`top-actions ${loginStep && 'close'}`}>
        {!loginStep && <button disabled={loading} onClick={resetLogin}>
          <img src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_back.svg" alt="back" />
        </button>}
        <button onClick={closeModal} disabled={loading}>
          <img src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_cancel.svg" alt="close" />
        </button>
      </div>
      <div className="row-top-information">
        <img className="logo" src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/illustrations/campo_mercado_dark.svg" height="50" width="200" alt="logo" />
        <h2>{title}</h2>
      </div>
      <div className="row-form">
        <div className="form-container">
          {(loginStep && !forgetPassStep) &&
            (<div className="form-horizontal">
              <div className="input-group">
                <input
                  className="form-control"
                  type="email"
                  name="username"
                  id="username"
                  onChange={handleUserEmail}
                  onKeyDown={pressEnter}
                  value={user.email}
                  required
                  placeholder={t('e_mail')}
                />
              </div>

              <div className="form-group submit" style={{
                padding: '0 10px'
              }}>
                <div className="row">
                  <button
                    className="btn-continue"
                    onClick={() => authEmail()}
                    disabled={!EMAIL_PATTERN.test(user.email) || loading}
                  >
                    Continuar {(loading && optionAuthCurrent.current == "email") && <i className="fas fa-spinner fa-spin"/>}
                  </button>
                </div>
              </div>
              <div className="divider"><span className="inner-text">O</span></div>
              <div className="form-group submit">
                <FacebookLogin
                  appId={process.env.REACT_APP_FACEBOOK_APPID}
                  fields="name,email,picture"
                  autoLoad={false}
                  callback={(e: any) => handleFacebookLogin(e)}
                  render={(renderProps: any) => (
                    <button onClick={renderProps.onClick} className="btn-social" disabled={loading}>
                      <div className="icon-container">
                        <img className="icon" src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_facebook_color.svg" />
                      </div>
                      Continuar con Facebook
                    </button>
                  )}
                />
              </div>
              <div className="form-group submit">
                <GoogleLogin
                  clientId={process.env.REACT_APP_GOOGLE_CLIENTID}
                  onSuccess={(e: any) => handleGoogleLogin(e)}
                  onFailure={handleSocialLoginFailure}
                  cookiePolicy={'single_host_origin'}
                  render={(renderProps: any) => (
                    <button onClick={renderProps.onClick} className="btn-social" disabled={loading}>
                      <div className="icon-container">
                        <img className="icon" src="https://campomercadobucket.s3.sa-east-1.amazonaws.com/assets/icons/ic_google_color.svg" />
                      </div>
                      Continuar con Google
                    </button>
                  )}
                  icon={false}
                />
              </div>
            </div>
          )}

          {(!loginStep && !forgetPassStep && emailSentStep) && (
            <div>
              <p>Siga los pasos enviados a {userCurrent.current.email} para recuperar su contraseña.</p>
              <div className="row" style={{
                padding: '0 12px',
              }}>
                <button className="btn-continue" onClick={resetLogin} style={{
                  marginTop: '25px',
                }}>Entendido</button>
              </div>
            </div>
          )}

          {(!loginStep && forgetPassStep && !emailSentStep) && (
            <form className="form-horizontal last-form">
              <div className="input-group">
              <input
                  className="form-control"
                  type="email"
                  autoFocus
                  onChange={handleUserEmail}
                  value={user.email}
                  required
                  placeholder={t('e_mail')}
                />
              </div>
              <div className="form-group submit">
                  <div className="row">
                  <button
                    className="btn-continue"
                    onClick={() => forgetPassword()}
                    disabled={!EMAIL_PATTERN.test(user.email) || loading}
                  >
                    Solicitar contraseña {loading && <i className="fas fa-spinner fa-spin"/>}
                  </button>
                  </div>
                </div>
            </form>
          )}

          {((!loginStep && !forgetPassStep && !emailSentStep) && (passwordIsRequired || phoneNumberIsRequired || namesIsRequired)) && (
            <>
              <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal last-form">
                {namesIsRequired && (
                  <>
                    <div className="input-group">
                      <input
                        className="form-control"
                        {...register("name.first", { required: true })}
                        type="text"
                        placeholder={"Nombre"}
                        autoFocus={namesIsRequired}
                      />
                    </div>
                    <div className="input-group">
                      <input
                        className="form-control"
                        {...register("name.last", { required: true })}
                        type="text"
                        placeholder={"Apellido"}
                      />
                    </div>
                  </>
                )}

                {phoneNumberIsRequired && (
                  <div className="input-group">
                    <select
                      name="phoneNumberCountry"
                      className="form-select"
                      id="phoneNumberCountry"
                      onChange={(e) => setCodePhoneNumberSelected(e.target.value)}
                    >
                      {PHONE_NUMBERS.map((country) => <option value={country.code}>{country.flag}</option>)}
                    </select>
                    <input
                      type="tel"
                      className="form-control"
                      style={{
                        flex: 3,
                      }}
                      {...register("phoneNumber.number", { required: true })}
                      autoComplete="false"
                    />
                  </div>
                )}

                {passwordIsRequired && (<div className="input-group" style={{
                    marginBottom: '0',
                  }}>
                  <input
                    className="form-control"
                    autoFocus={resetPasswordIsAvailable && !phoneNumberIsRequired}
                    {...register("password", { required: true })}
                    type="password"
                    placeholder={t('password')}
                  />
                </div>)}

                {resetPasswordIsAvailable && (<button className="btn btn-link forgot-pass-link" type="button" onClick={goToForgotPassword}>{FORGOT_TITLE}</button>)}
                <div className="form-group submit">
                  <div className="row">
                  <button
                    className="btn-continue"
                    type="submit"
                    disabled={!isDirty || !isValid || loading}
                  >
                    Ingresar {loading && <i className="fas fa-spinner fa-spin"/>}
                  </button>
                  </div>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const LoginModal = ({
  modalIsOpen,
  afterOpenModal,
  closeModal,
  nextAction,
  classname,
  actionText,
}: {
  modalIsOpen: any,
  afterOpenModal?: any,
  closeModal: any,
  nextAction?: any,
  classname: string,
  actionText?: string,
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Login"
    >
      <Login nextAction={nextAction ? nextAction : closeModal} closeModal={closeModal} classname={classname} actionText={actionText} />
    </Modal>
  );
}

export default LoginModal;
